export default __webpack_public_path__ + "static/media/rajesh_chandela.98831bce.png";